var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.794 5.323 12.386.32c-.364-.382-.949-.418-1.333-.124s-.447.888-.133 1.246l3.139 3.56H.944c-.521 0-.944.396-.944.884 0 .487.423.883.944.883H14.06l-3.138 3.56c-.315.359-.244.944.132 1.246.388.312 1.02.235 1.333-.124l4.408-5.004c.287-.377.262-.758 0-1.123Z"
  })));
};
export default SvgArrow;